import React from 'react';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
export default props => (
  <MuiPickersUtilsProvider utils={MomentUtils} {...props} />
);



// WEBPACK FOOTER //
// ./src/components/uielements/materialUiPicker/momentProvider.js